import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Search = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M27.712 26.288L21.75 20.313C23.163 18.588 24.012 16.388 24.012 13.988C24.012 8.47598 19.524 3.98798 14.012 3.98798C8.49996 3.98798 4.01196 8.47598 4.01196 13.988C4.01196 19.5 8.49996 23.988 14.012 23.988C16.412 23.988 18.612 23.138 20.337 21.726L26.299 27.688C26.474 27.863 26.724 27.976 27.011 27.976C27.561 27.976 28.011 27.526 28.011 26.976C27.999 26.726 27.886 26.476 27.711 26.288H27.712ZM14 22C9.58796 22 5.99996 18.413 5.99996 14C5.99996 9.58698 9.58796 5.99998 14 5.99998C18.412 5.99998 22 9.58798 22 14C22 18.412 18.413 22 14 22Z" />
	</svg>
);

export default Search;
